import ResizeObserver from 'resize-observer-polyfill';
var isServer = typeof window === 'undefined';
/**
 * @desc 元素大小变化时的动作
 * @param {Array} entries 监听元素的集合
 */

var resizeHandler = function resizeHandler(entries) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var entry = _step.value;
      var listeners = entry.target.__resizeListeners__ || [];

      if (listeners.length) {
        listeners.forEach(function (fn) {
          fn();
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};
/**
 * @desc 监听元素大小变化
 * @param {Document} el 监听的元素
 * @param {Function} fn 回调函数
 */


var onResize = function onResize(el, fn) {
  if (isServer) return;

  if (!el.__resizeListeners__) {
    el.__resizeListeners__ = [];
    el.__ro__ = new ResizeObserver(resizeHandler);

    el.__ro__.observe(el);
  }

  el.__resizeListeners__.push(fn);
};

export default onResize;